<template>
    <div>
        <error-component
                v-if="exceptions.length > 0"
                v-bind="exceptions[0]">
        </error-component>
        <div v-if="loading">
            <bouncing-component></bouncing-component>
        </div>
        <div v-else>
            <div v-if="status == 'forbidden'">
                <span>You can't get access to this report because you are not member of {{organizationOwner}}</span>
            </div>
            <div v-if="status === 'Private' && !$auth.check()">
                <span>This is a private report</span>
            </div>
            <div v-else ref="fullscreen">
                <render-component :report_id="report_id"></render-component>
                <div class="footer">
                    <b-button @click="toggle" class="pull-right full-screen" variant="default">
                        <font-awesome-icon v-if="fullscreen" icon="compress"/>
                        <font-awesome-icon v-else icon="expand"/>
                    </b-button>
                    <a :href="route" v-b-tooltip.hover title="Open Report in Data Providers" class="pull-right logo" target="_blank">Data Providers</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import RenderComponent from '../Render.vue';
    import ErrorComponent from '../../../components/ErrorView.vue';
    import BouncingComponent from '../../../components/Bouncing-loader.vue';
    export default {
        props: ['report_id'],
        data() {
            return {
                fullscreen: false,
                route: '',
                loading: true
            }
        },
        components: {
            RenderComponent,
            ErrorComponent,
            BouncingComponent
        },
        created() {
            $('html').removeClass('login');
            let payload = {
                report_id: this.report_id,
                routeQuery: this.$route.query
            };
            this.$store.dispatch('reports/fetchSharedReport', payload).then(() => {
                this.loading = false;
            });
            this.route = `${this.baseUrl}/#/report/${this.report_id}`
        },
        computed: {
            ...mapState('reports', {
                status: 'status'
            }),
            ...mapState({
                exceptions: 'exceptions',
                baseUrl: state => state.baseUrl,
            })
        },
        beforeDestroy() {
            this.$store.commit('reports/CLEAR_REPORT_ELEMENTS');
            this.$store.commit('reports/SET_REPORT_STATUS', 'public');
            this.$store.commit('reports/SET_REPORT_ORGANIZATION', '');
            this.$store.commit('reports/SET_REPORT_PARAMETERS', []);
            this.$store.commit('CLEAR_EXCEPTIONS');
        },
        methods: {
            toggle () {
                this.$fullscreen.toggle(this.$refs['fullscreen'], {
                    wrap: true,
                    callback: this.fullscreenChange,
                    background: '#FFFFFF'
                })
            },
            fullscreenChange (fullscreen) {
                this.fullscreen = fullscreen
            }
        },
    }
</script>

<style scoped>
    .footer {
	position: fixed;
	bottom: 0;
	width: 100%;
	height: 22px;
	background-color: #f5f5f5;
    }
    .footer .logo {
	font-family: 'Teko', sans-serif;
    font-size: 18px;
    color: #444;
    }
    .full-screen {
        padding: 0;
        margin-left: 5px;
    }
</style>
